import axios from "axios";
import { BACKEND_URL } from "./config";
import { Location } from "react-router-dom";
import { User } from "./types";

export function getCookie(name: string) {
  // for django csrf protection
  if (document.cookie && document.cookie !== "") {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }
  }
  return null;
}

export function timeSince(date: Date) {
  var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

export function fileToBase64(file: File) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}

export async function respondToMatching(
  userId: string | number,
  response: "like" | "dislike" | "skip",
  token: string,
  callback?: (res: any) => void
) {
  const res = await axios.post(
    `${BACKEND_URL}/api/matching/`,
    JSON.stringify({
      response,
      other: userId,
    })
  );
  callback && callback(res);
}

export const fetchUserInfo = async (
  location: Location,
  posthog: any,
  setUser: (user: User) => void
) => {
  axios.get(BACKEND_URL + "/api/users/me/").then(
    (response) => {
      if (
        location.pathname.startsWith("/app/") &&
        !location.pathname.startsWith("/app/profile/") &&
        !response["data"].id &&
        !response["data"].is_profile_completed
      ) {
        window.location.href = "/app/profile/";
      }
      setUser(response["data"]);
      posthog?.identify(response["data"].id, {
        email: response["data"].email,
      });
      posthog?.capture("User logged in", {
        email: response["data"].email,
      });
      return response["data"];
    },
    (error) => {
      console.log(error);
    }
  );
};
